import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MetaService } from '../meta.service';
@Component({
  selector: 'app-software-product-development',
  templateUrl: './software-product-development.component.html',
  styleUrls: ['./software-product-development.component.scss']
})
export class SoftwareProductDevelopmentComponent implements OnInit {
  title = 'Innovative Software Development Solutions | Qaptive Technologies India';
  constructor(
    private titleService: Title, 
    private metaService: MetaService,
    private meta: Meta
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.meta.updateTag(
      { name: 'description', content: "Unlock your business potential with quality product software development from Qaptive, a trusted software development partner in India." }
    );
    this.metaService.createCanonicalURL();
  }

}
